//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './GDTOutgoingTemplatesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type GetSingleGDTOutgoingTemplatesQueryParameters = {
  id: number ;
}

export type PatchGDTOutgoingTemplatesQueryParameters = {
  id: number ;
}

export type RemoveGDTOutgoingTemplatesQueryParameters = {
  id: number ;
}

export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/gdt/out-templates";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.TemplateListDto[], unknown, Types.TemplateListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TemplateListDto[], unknown, Types.TemplateListDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'GDTOutgoingTemplatesClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

/**
 * Gets all templates that are available
 */
export function useGetQuery<TSelectData = Types.TemplateListDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.TemplateListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.TemplateListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TemplateListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TemplateListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.TemplateListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all templates that are available
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.TemplateListDto[] | undefined) => Types.TemplateListDto[], ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

/**
 * Gets all templates that are available
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TemplateListDto[] | undefined) => Types.TemplateListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/gdt/out-templates";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'GDTOutgoingTemplatesClient',
      'create',
    ]);
}

/**
 * Creates a document template.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.TemplateDto, unknown, Types.CreateTemplateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TemplateDto, unknown, Types.CreateTemplateDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateTemplateDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/out-templates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.TemplateDto, unknown, Types.TemplateDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TemplateDto, unknown, Types.TemplateDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleGDTOutgoingTemplatesQueryParameters;

    return trimArrayEnd([
        'GDTOutgoingTemplatesClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'GDTOutgoingTemplatesClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.TemplateDto, TError = unknown>(dto: GetSingleGDTOutgoingTemplatesQueryParameters, options?: Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets full information (including Content) of a single GDT Template
 */
export function useGetSingleQuery<TSelectData = Types.TemplateDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.TemplateDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TemplateDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleGDTOutgoingTemplatesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TemplateDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.TemplateDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets full information (including Content) of a single GDT Template
 */
export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.TemplateDto | undefined) => Types.TemplateDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

/**
 * Gets full information (including Content) of a single GDT Template
 */
export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TemplateDto | undefined) => Types.TemplateDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/out-templates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'GDTOutgoingTemplatesClient',
      'patch',
      id as any,
    ]);
}

/**
 * Edits a GDT template.
 * @param id The GDT template id.
 * @param dto Request parameter
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.TemplateDto, unknown, Types.PatchTemplateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TemplateDto, unknown, Types.PatchTemplateDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchTemplateDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchGDTOutgoingTemplatesQueryParameters & {
  dto: Types.PatchTemplateDto;
}

/**
 * Edits a GDT template.
 * @param id The GDT template id.
 * @param dto Request parameter
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.TemplateDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchGDTOutgoingTemplatesQueryParameters}): UseMutationResult<Types.TemplateDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/gdt/out-templates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'GDTOutgoingTemplatesClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes a document template.
 * @param id The document template id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveGDTOutgoingTemplatesQueryParameters

/**
 * Removes a document template.
 * @param id The document template id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveGDTOutgoingTemplatesQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}